export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12151.bbf2543c.jpg";